import React from "react";
import FanFilterSelect from "./FanFilterSelect";
import FilterErrorIcon from "./FilterErrorIcon";

import { formInputContainerStyle } from "./FanFilterGroupForm";

const ProductConditionForm = (props) => {
  const {
    fanFilter,
    updateFanFilter,
    productsOptionKey,
    productIdParam,
    anyProductLabel,
  } = props;

  const conditions = fanFilter.filter_param_options.condition || [];
  const products = fanFilter.filter_param_options[productsOptionKey] || [];

  const condition = fanFilter.filter_params.condition || "";
  const productId = fanFilter.filter_params[productIdParam] || null;

  const productOptions = products.map((product) => ({ value: product.id, label: product.name || "" }));
  const selectedProduct = products.find((product) => String(product.id) === String(productId));

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a condition"
          placeholder="Select a condition"
          options={conditions.map((cond) => ({ value: cond, label: cond }))}
          value={condition || null}
          onChange={(value) => {
            updateFanFilter({
              filter_params: {
                condition: value,
                [productIdParam]: null,
              },
            });
          }}
        />
      </div>

      {condition && (
        <div style={formInputContainerStyle}>
          <FanFilterSelect
            aria-label={anyProductLabel}
            placeholder={anyProductLabel}
            searchable
            clearable
            options={productOptions}
            value={selectedProduct ? selectedProduct.id : productId}
            onChange={(value) => {
              updateFanFilter({
                filter_params: {
                  ...fanFilter.filter_params,
                  [productIdParam]: value ?? null,
                },
              });
            }}
          />
        </div>
      )}

      <FilterErrorIcon errors={fanFilter.filter_validation_errors} />
    </>
  );
};

export default ProductConditionForm;
